const pluralVariations = [
  'zero',
  'one',
  'two',
  'few',
  'many',
  'other'
];

class XCStrings {

  constructor(text) {
    this.sourceStrings = {};
    this.targetStrings = {};
    if (text) {
      this.structure = JSON.parse(text);
      this.sourceLanguage = this.structure['sourceLanguage'];
      const strings = this.structure['strings'];
      if (strings) {
        const keys = Object.keys(strings);
        if (keys && Array.isArray(keys)) {
          for (const key of keys) {
            var sourceValue = {state: 'new', value: key};
            const string = strings[key];
            sourceValue.comment = string['comment'];
            const localizations = string['localizations'];
            if (localizations) {
              const localLanguages = Object.keys(localizations);
              if (localLanguages && Array.isArray(localLanguages)) {
                for (const language of localLanguages) {
                  const localizationBlock = localizations[language];
                  if (localizationBlock) {
                    const stringUnit = localizationBlock['stringUnit'];
                    if (stringUnit) {
                      if (language === this.sourceLanguage) {
                        sourceValue = stringUnit;
                      }
                      else {
                        if (!this.targetStrings[language]) {
                          this.targetStrings[language] = {};
                        }
                        this.targetStrings[language][key] = stringUnit;
                      }
                    }
                    else {
                      const variations = localizationBlock['variations'];
                      if (variations) {
                        sourceValue = null;
                        const device = variations['device'];
                        if (device) {
                          const devices = Object.keys(device);
                          if (devices) {
                            for (const deviceKey of devices) {
                              const deviceValue = device[deviceKey];
                              if (deviceValue) {
                                const dkey = `device~${deviceKey}~${key}`;
                                var dvalue = deviceValue['stringUnit'];
                                if (dvalue) {
                                  var comment = (string['comment'] ? string['comment'] : '');
                                  comment += ` //## variation for device: ${deviceKey}`;
                                  dvalue.comment = comment;
                                  if (language === this.sourceLanguage) {
                                    this.sourceStrings[dkey] = dvalue;
                                  }
                                  else {
                                    if (!this.targetStrings[language]) {
                                      this.targetStrings[language] = {};
                                    }
                                    if (dvalue['state'] === 'translated') {  
                                      this.targetStrings[language][dkey] = dvalue;
                                    }
                                    else {
                                      const combinedValue = Object.assign({}, dvalue);
                                      combinedValue['value'] = localizations[this.sourceLanguage]['variations']['device'][deviceKey]['stringUnit']['value'];
                                      this.targetStrings[language][dkey] = combinedValue;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                        const plural = variations['plural'];
                        if (plural) {
                          for (const pluralKey of pluralVariations) {
                            const otherValue = plural['other'];
                            const firstKey = Object.keys(plural)[0];
                            const firstValue = plural[firstKey];
                            const pluralValue = plural[pluralKey] || otherValue || firstValue;
                            if (pluralValue) {
                              const pkey = `plural~${pluralKey}~${key}`;
                              var pvalue = pluralValue['stringUnit'] ? Object.assign({}, pluralValue['stringUnit']) : null;
                              if (pvalue) {
                                pvalue.comment = (string['comment'] ? string['comment'] : '') + ` //## variation for plural value: ${pluralKey}`;
                                if (language === this.sourceLanguage) {
                                  this.sourceStrings[pkey] = pvalue;
                                }
                                else {
                                  if (!this.targetStrings[language]) {
                                    this.targetStrings[language] = {};
                                  }
                                  if (pvalue['state'] === 'translated') { 
                                    this.targetStrings[language][pkey] = pvalue;
                                  }
                                  else {
                                    const combinedValue = Object.assign({}, pvalue);
                                    if (localizations[this.sourceLanguage]['variations']['plural'][pluralKey]) {
                                      combinedValue['value'] = localizations[this.sourceLanguage]['variations']['plural'][pluralKey]['stringUnit']['value'];
                                    }
                                    else {
                                      const keys = Object.keys(localizations[this.sourceLanguage]['variations']['plural']);
                                      if (keys && keys.length > 0) {
                                        const pk = keys[0];
                                        combinedValue['value'] = localizations[this.sourceLanguage]['variations']['plural'][pk]['stringUnit']['value'];
                                      }
                                    }
                                    this.targetStrings[language][pkey] = combinedValue;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            if (sourceValue) {
              this.sourceStrings[key] = sourceValue;
            }
          }
        }
      }
    }
    else {
      this.structure = {};
    }
  }

  _keyValueToString(key, value) {
    var string = "";
    if (key && value) {
      string = `"${key}" = "${value.value}";`;
      if (value.comment) {
        string += ` // ${value.comment}`;
      }
    }
    return string + "\n";
  }

  convertToStrings(options) {
    var stringsStructure = {};
    if (this.sourceLanguage) {
      stringsStructure[this.sourceLanguage] = "";
    }
    const languageKeys = Object.keys(this.targetStrings);
    for (const languageKey of languageKeys) {
      stringsStructure[languageKey] = "";
    }
    const keys = Object.keys(this.sourceStrings);
    if (keys && Array.isArray(keys)) {
      for (const key of keys) {
        const value = this.sourceStrings[key];
        stringsStructure[this.sourceLanguage] += this._keyValueToString(key, value);
        for (const languageKey of languageKeys) {
          const targetValue = this.targetStrings[languageKey][key];
          if (targetValue) {
            if (!options || !options['skipTranslated'] || 
                (targetValue.state === 'new' || targetValue.state === 'needs_review')) {
              stringsStructure[languageKey] += this._keyValueToString(key, targetValue);
            }
          }
          else {
            stringsStructure[languageKey] += this._keyValueToString(key, value);
          }
        }
      }
    }
    return {strings: stringsStructure};
  }

  fixStringsFile(inputString) {
    if (!inputString) {
      return inputString;
    }
    const regex = /("([^"]+)"\s*=\s*")([^"]*)(")/g;
    const fixedString = inputString.replace(regex, (match, prefix, key, value, suffix) => {
      const fixedKey = key.replace(/\n/g, '\\n');
      const fixedValue = value.replace(/\n/g, '\\n');
      return `${prefix}${fixedKey}" = "${fixedValue}${suffix}`;
    });
    return fixedString;
  }

  _updateStructure() {
    this.structure['sourceLanguage'] = this.sourceLanguage;
    var strings = {};
    const keys = Object.keys(this.sourceStrings);
    if (keys && Array.isArray(keys)) {
      for (const key of keys.sort()) {
        const value = this.sourceStrings[key];
        var string = {};
        const { ['comment']: _, ...newValue } = value;
        string['stringUnit'] = newValue;
        const deviceMatch = key.match(/^device~([^~]+)~(.*)$/);
        const pluralMatch = key.match(/^plural~([^~]+)+~(.*)$/);
        if (deviceMatch) {
          const deviceValue = deviceMatch[1];
          const deviceKey = deviceMatch[2];
          if (!strings[deviceKey] || !strings[deviceKey]['localizations'][this.sourceLanguage]) {
            strings[deviceKey] = {localizations: {[this.sourceLanguage]: {variations: {device: {[deviceValue]: {stringUnit: string}}}}}};
          }
          else {
            strings[deviceKey]['localizations'][this.sourceLanguage]['variations']['device'][deviceValue] = {stringUnit: string};
          }
          for (const lang of Object.keys(this.targetStrings)) {
            var targetValue = this.targetStrings[lang][key];
            if (targetValue) {
              const { ['comment']: _, ...newTargetValue } = targetValue;
              if (!strings[deviceKey]['localizations'][lang]) {
                strings[deviceKey]['localizations'][lang] = {variations: {device: {[deviceValue]: {stringUnit: newTargetValue}}}};
              }
              else {
                strings[deviceKey]['localizations'][lang]['variations']['device'][deviceValue] = {stringUnit: newTargetValue};
              }
            }
          }
          if (value.comment) {
            var comment = value.comment;
            strings[deviceKey]['comment'] = comment;
          }
        }
        else if (pluralMatch) {
          const pluralValue = pluralMatch[1];
          const pluralKey = pluralMatch[2];
          if (!strings[pluralKey] || !strings[pluralKey]['localizations'][this.sourceLanguage]) {
            strings[pluralKey] = {localizations: {[this.sourceLanguage]: {variations: {plural: {[pluralValue]: {stringUnit: string}}}}}};
          }
          else {
            strings[pluralKey]['localizations'][this.sourceLanguage]['variations']['plural'][pluralValue] = {stringUnit: string};
          }
          for (const lang of Object.keys(this.targetStrings)) {
            var targetValue = this.targetStrings[lang][key];
            if (targetValue) {
              const { ['comment']: _, ...newTargetValue } = targetValue;
              if (!strings[pluralKey]['localizations'][lang]) {
                strings[pluralKey]['localizations'][lang] = {variations: {plural: {[pluralValue]: {stringUnit: newTargetValue}}}};
              }
              else {
                strings[pluralKey]['localizations'][lang]['variations']['plural'][pluralValue] = {stringUnit: newTargetValue};
              }
            }
          }
          if (value.comment) {
            var comment = value.comment;
            strings[pluralKey]['comment'] = comment;
          }
        }
        else {
          strings[key] = {localizations: {[this.sourceLanguage]: string}};
          for (const lang of Object.keys(this.targetStrings)) {
            const targetValue = this.targetStrings[lang][key];
            if (targetValue) {
              strings[key]['localizations'][lang] = {stringUnit: targetValue};
            }
          }
          if (value.comment) {
            var comment = value.comment;
            strings[key]['comment'] = comment;
          }
        }
      }
    }
    this.structure['strings'] = strings;
    this.structure['version'] = '1.0';
  }

  importFromStrings(text, language) {
    if (!this.sourceLanguage) {
      this.sourceLanguage = language;
    }
    const input = this.fixStringsFile(text);
    if (input) {
      const lines = input.split("\n");
      for (const line of lines) {
        const regex = /"([^"]+)"\s*=\s*"([^"]*)";(.*)/;
        const match = regex.exec(line);
        if (match) {
          const key = match[1];
          const value = match[2];
          var comment = null;
          const untrimmedComment = match[3];
          if (untrimmedComment) {
            comment = untrimmedComment.replace(/^\s*\/\/\s*/, '').trim();
            comment = comment.replace(/\/\/\#\# variation for .*$/, '').trim();
          }
          if (this.sourceLanguage === language) {
            if (!this.sourceStrings[key]) {
              var sourceValue = {state: 'translated', value: value};
              if (comment) {
                sourceValue.comment = comment;
              }
              this.sourceStrings[key] = sourceValue;
            }
          }
          else {
            if (!this.targetStrings[language]) {
              this.targetStrings[language] = {};
            }
            this.targetStrings[language][key] = {state: 'translated', value: value};
          }
        }
      }
      this._updateStructure();
    }
  }

  targetLanguages() {
    return this.targetStrings ? Object.keys(this.targetStrings) : [];
  }

  toString() {
    return JSON.stringify(this.structure, null, '  ');
  }
}

module.exports = XCStrings;
